/*/ ## Assessment
//
// Object for loading assessment questions. To get a login to our Survey/Assessment
// Engine please contact us at engineering@everfi.com.
//
// Some sample code for loading an assessment:
//     var assmnt = new Assessement({slug: "awesome"})
//     assmnt.loadQuestions(function(questions){
//       var assessment = this;
//       // Render the assessment
//     });
/*/
(function(EF, undefined) {

  var Assessment = Backbone.Model.extend({

    // Assessment JSON endpoint is
    // http://survey.everfi.net/surveys/:survey-slug-name/questions.json
    questionsUrl: function() {
     var base = EF.config.get('assessmentEndpoint');
     return base + 'api/surveys/' + this.get('slug') + '/questions.json?callback=?';
    },

    assessUrl: function() {
     var base = EF.config.get('assessmentEndpoint');
     return base + '/surveys/assess.json?callback=?';
    },

    // loads the assessment's question from the assessment endpoint
    // takes an options hash that may include a success callback that will be
    // called with the loaded questions
    loadQuestions: function(options) {
      var assmnt = this;
      var cb = options && options.success;
      $.getJSON(this.questionsUrl(), function(questions) {
        assmnt.questions = new EF.Collections.Questions(questions);
        if(cb) cb.apply(assmnt, [assmnt.questions]);
      });
    },

    // Respond to the assessment with answers in the following format:
    //
    //     [
    //       {
    //         questionid: '123',
    //         answerid: '123'
    //       },
    //       {
    //         questionid: '123',
    //         answerid: '123'
    //       }
    //     ]
    //
    recordResponse: function(response, options) {
      var cb = options && _.bind(options.success, this);

      var responsePackage = _.map(response, function(qq) {
        return {
          'id': qq.questionId,
          'as': [ { 'id': qq.answerId } ]
        };
      });

      var args = {user_id: EF.enrollment.get('id'), rs: responsePackage};
      $.getJSON(this.assessUrl(), args, cb);
    }

  });

  _.extend(EF.Models, {
    Assessment: Assessment
  });

})(EF);


